import { Fragment } from 'react';
import { useState, useEffect } from 'react';

import { TableBasic } from '../../components/TableBasic';
import { FilterProducts } from './components/FilterProducts';

const tableTitle = 'products';

export const ProductsScreen = ({ data, type }) => {

  const [filterArray, setFilterArray] = useState([]);
  const [copyArray, setCopyArray] = useState(data);

  useEffect(() => {
    if (data) {
      if (type) {
        setFilterArray(data.filter((product) => product.type === type))
      } else {
        setFilterArray(data);
      }
    };

}, [data, type])


  return (
    <Fragment>
      <FilterProducts setFilterArray={setFilterArray} copyArray={copyArray}/>
      <TableBasic rows={filterArray} tableTitle={tableTitle} colNames={colNames} values={values} setFilterArray={setFilterArray} setCopyArray={setCopyArray} />
    </Fragment>
  )
}

const colNames = ['Producto', 'Unidad', 'Precio/día', 'Categoria', ''];

const values = ['product', 'measure', 'price', 'type' ];